import { useRefinementList } from "@hooks/search/useRefinementList"
import { UseRefinementListProps } from "react-instantsearch-core"

const VirtualRefinementList = (props: UseRefinementListProps) => {
  useRefinementList(props)

  return null
}

export default VirtualRefinementList
